function initSourceObserver(source){updateBundleButton(source)
const observer=new MutationObserver(()=>{updateBundleButton(source)});observer.observe(source,{childList:!0,characterData:!0,subtree:!0})}
function updateBundleButton(source){const text=source.innerText;const button=source.closest('.mbc-bundle__wrapper').querySelector(".mbc-bundle__footer .mbc-bundle__atc");if(!button)return
if(!button.hasAttribute('data-original-text')){button.setAttribute('data-original-text',button.innerText)}
button.innerText=button.getAttribute('data-original-text')+' · '+text}
const bodyObserver=new MutationObserver(()=>{const sourceArr=document.querySelectorAll(".mbc-bundle__footer .mbc-bundle__price span");if(sourceArr.length>0){sourceArr.forEach(source=>{initSourceObserver(source)});bodyObserver.disconnect()}});if(document.querySelector('#mbcBundleItemsWidget')){bodyObserver.observe(document.body,{childList:!0,subtree:!0})}

// Header loaded class
window.addEventListener("load", function() {
  document.querySelectorAll(".shopify-section-group-header-group")
    .forEach(el => el.classList.add("loaded"));
});
